import { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext({ dark: false, toggle: () => {} });

export function AdminThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem("driveline-admin-theme") === "dark";
  });

  // v4.6.15 — the `dark` class must also live on <html>, otherwise the global
  // light-palette overrides in index.css (html[data-theme]:not(.dark) .bg-white
  // { … !important }) keep repainting admin cards white in dark mode.
  useEffect(() => {
    localStorage.setItem("driveline-admin-theme", dark ? "dark" : "light");
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    return () => root.classList.remove("dark");
  }, [dark]);

  const value = useMemo(
    () => ({ dark, toggle: () => setDark((d) => !d) }),
    [dark]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useAdminTheme = () => useContext(ThemeContext);
